import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {PingService} from "../services/ping/ping.service";

@Injectable()
export class PingInterceptor implements HttpInterceptor {
  private readonly INTERVAL_PERIOD = 60000;
  private readonly REPEAT_PING_COUNT = 30;

  constructor(private pingService: PingService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.pingService.initialisePingInterval(this.REPEAT_PING_COUNT, this.INTERVAL_PERIOD);
    return next.handle(req);
  }
}
